// import { Add } from "@mui/icons-material";
import { LinearProgress, Stack, Typography } from "@mui/material";
import { useGetMedicationTitrationsQuery } from "src/api/services/medicationTitrationsApi";
import DataTable from "src/components/DataTable";
import WhiteCard from "src/components/WhiteCard";
import { useColumns } from "./useColumns";

interface Props {
  titrationId: number;
}

const MedicationTitrations = ({ titrationId }: Props) => {
  const { data: medicationTitrations = [], isLoading } =
    useGetMedicationTitrationsQuery({
      titration_id: titrationId,
    });

  const columns = useColumns();

  return (
    <WhiteCard width={"1000px"} gap={3}>
      <Stack gap={1}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography fontWeight={600}>Medication titration</Typography>
          {/* <IconButton>
            <Add color="secondary" />
          </IconButton> */}
        </Stack>
        {isLoading ? (
          <LinearProgress />
        ) : (
          <DataTable
            data={medicationTitrations}
            columns={columns}
            primaryKey="id"
          />
        )}
      </Stack>
    </WhiteCard>
  );
};

export default MedicationTitrations;
